/* @flow */

import { createSelector } from '@reduxjs/toolkit';
import { hydrateUser } from '@e180/domain/lib/user/util';

import type { User } from '@e180/domain/lib/user/type';
import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Slices
 |------------------------------------------------------------------------------
 */

const getAppUser = (state) => state.app.user;
const getEntities = (state) => state.domain.entities;
const getUserIdFromProps = (state, props: Object) => props.id;

/*
 |------------------------------------------------------------------------------
 | Exports
 |------------------------------------------------------------------------------
 */

export const getUser: (state: State, props: Object) => any = createSelector(
  [getUserIdFromProps, getEntities],
  (id, entities): any => {
    if (id) {
      return hydrateUser(id, entities);
    }
  },
);

export const getSelf: (state: State) => ?User = createSelector(
  [getAppUser, getEntities],
  (id, entities) => {
    if (id) {
      return hydrateUser(id, entities);
    }
  },
);

export const getUserId: (state: State) => number = createSelector(
  [getAppUser],
  (x) => x,
);
